import axios from "axios";
import { TSongSheet } from "../types/SongSheet";
import { mockSongSheetData } from "../data/mockdata";
import { getDebugMode } from "../store/debug";
import SongSheet from "../pages/SongSheet";

const processGetRequest = (
  url: string,
  callback: any,
  errorcallback: any,
  mockData: any = null
) => {
  if (getDebugMode()) {
    console.log(mockData);
    return callback(mockData);
  } else {
    axios
      .get(url)
      .then((res) => {
        //do something
        if (callback != null) {
          console.log(res);
          callback(res);
        }
      })
      .catch((err) => {
        // catch error
        if (errorcallback != null) {
          errorcallback(err);
        }
      });
  }
};

export const GetSongSheetById = (
  id: string,
  callback: any,
  errorcallback: any
) => {
  const mockSong = {
    data: {
      message: "song sheets retrieved woo!",
      songSheet: mockSongSheetData.data.songSheets.find(
        (SongSheet) => SongSheet._id == id
      ),
    },
  };
  processGetRequest(
    `${process.env.REACT_APP_API_URL}/songSheets/${id}`,
    callback,
    errorcallback,
    mockSong
  );
};

export const GetSongSheets = (callback: any, errorcallback: any) => {
  processGetRequest(
    `${process.env.REACT_APP_API_URL}/songSheets`,
    callback,
    errorcallback,
    mockSongSheetData
  );
};

export const GetSongSheetByTags = (
  tags: string[],
  callback: any,
  errorcallback: any
) => {
  axios
    .get(`${process.env.REACT_APP_API_URL}/songSheets?tags=${tags.toString()}`)
    .then((res) => {
      //do something
      if (callback != null) {
        callback(res);
      }
    })
    .catch((err) => {
      // catch error
      if (errorcallback != null) {
        errorcallback(err);
      }
    });
};

export const GetSongSheetByFolder = (
  folder: string,
  callback: any,
  errorcallback: any
) => {
  axios
    .get(`${process.env.REACT_APP_API_URL}/songSheets?folder=${folder}`)
    .then((res) => {
      //do something
      if (callback != null) {
        callback(res);
      }
    })
    .catch((err) => {
      // catch error
      if (errorcallback != null) {
        errorcallback(err);
      }
    });
};

export const DeleteSongSheetById = (
  id: string,
  callback: any,
  errorcallback: any
) => {
  axios
    .delete(`${process.env.REACT_APP_API_URL}/songSheets/${id}`)
    .then((res) => {
      //do something
      if (callback != null) {
        callback(res);
      }
    })
    .catch((err) => {
      // catch error
      if (errorcallback != null) {
        errorcallback(err);
      }
    });
};

export const CreateSongSheet = (
  songSheet: TSongSheet,
  callback: any,
  errorcallback: any
) => {
  console.log(songSheet);
  axios({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/songSheets`,
    data: songSheet,
    headers: { "Content-Type": "application/json;charset=utf-8" },
  })
    .then((res) => {
      //do something
      if (callback != null) {
        callback(res);
      }
    })
    .catch((err) => {
      // catch error
      if (errorcallback != null) {
        errorcallback(err);
      }
    });
};

export const UpdateSongSheet = (
  songSheetId: string | undefined,
  songSheet: TSongSheet,
  callback: any,
  errorcallback: any
) => {
  axios({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/songSheets/${songSheetId}`,
    data: songSheet,
    headers: { "Content-Type": "application/json;charset=utf-8" },
  })
    .then((res) => {
      //do something
      if (callback != null) {
        callback(res);
      }
    })
    .catch((err) => {
      // catch error
      if (errorcallback != null) {
        errorcallback(err);
      }
    });
};
